<template>
    <div :style="shu.yangshi">
		<div  v-for="(l,i) in shu.shu" style="width: 100%;padding: 20px;box-sizing: border-box;" :key="i">
			<el-row>
				<el-col :span="18" style="text-align: left;color: #333333;font-size: 12px;"><div>{{l.biaoti}}</div></el-col>
				<el-col :span="6"><el-button type="warning" round size="mini">联系他</el-button></el-col>
			</el-row>
			<el-row>
				<el-col :span="24"><div  style="color: #999999;text-align: left;font-size: 14px;">{{l.lianxiren}}</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="24"><div  style="color: #999999;text-align: left;font-size: 14px;">{{l.dizhi}}</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="6"><div   style="color: #FD0539;text-align: left;font-size: 14px;">{{l.xinzi}}</div></el-col>
				<el-col :span="18"><div  style="color: #999999;text-align: right;font-size: 14px;">{{l.shijian}}</div></el-col>
			</el-row>
		</div>
	</div>
</template>
 
<script>
export default {
  name: 'jianzhi',
		data(){
			return {}
        }, 
		props: {
			shu: {
				type: Object,
				default () {
					return {
						wenzi: '输入文字',
						yangshi: {}
					}
				}
			}
		},
		created() {
			this.CSH();			
		},
		methods:{
			CSH(){
				var that=this;
				if(!this.shu.shu){
					var shu={ye:1,jitiao:8};											
					this.$post('m=zw_pige&k=jianzhi',shu,function(s) {
						if (s.shi == 1) {	
							that.$set(that.shu, "shu",s.shu.lie);									
						}
					});
				}				
			}
		}

}
</script>
